import React from "react";
import { Redirect } from "react-router-dom";

// Layout Types
import { DefaultLayout,Full } from "./layouts";

// Route Views
import Dashboard from "./Dashboard/Dashboard";
import UserList from "./Users/UserList";
import UserAdd from "./Users/UserAdd";
import UserProfileLite from "./views/UserProfileLite";
import AddNewPost from "./views/AddNewPost";
import Errors from "./views/Errors";
import ComponentsOverview from "./views/ComponentsOverview";
import Tables from "./views/Tables";
import BlogPosts from "./views/BlogPosts";
import UserViewUpdate from "./Users/UserViewUpdate";
import DepartmentsAdd from "./Departments/DepartmentsAdd";
import DepartmentsList from "./Departments/DepartmentsList";
import DepartmentsViewUpdate from "./Departments/DepartmentsViewUpdate";
import AppInfo from "./AppInfo/AppInfo";
//
import Bikes from './Bikes/Bikes';

            import BikesAdd from './Bikes/BikesAdd';

            import BikesViewUpdate from './Bikes/BikesViewUpdate';
//
import Courses from './Courses/Courses';

            import CoursesAdd from './Courses/CoursesAdd';

            import CoursesViewUpdate from './Courses/CoursesViewUpdate';
//
import Category from './Category/Category';

            import CategoryAdd from './Category/CategoryAdd';

            import CategoryViewUpdate from './Category/CategoryViewUpdate';
//
import SubCategory from './SubCategory/SubCategory';

            import SubCategoryAdd from './SubCategory/SubCategoryAdd';

            import SubCategoryViewUpdate from './SubCategory/SubCategoryViewUpdate';
            import Chapters from './Chapters/Chapters';

            import ChaptersAdd from './Chapters/ChaptersAdd';

            import ChaptersViewUpdate from './Chapters/ChaptersViewUpdate';
            import Exercises from './Exercises/Exercises';

            import ExercisesAdd from './Exercises/ExercisesAdd';

            import ExercisesViewUpdate from './Exercises/ExercisesViewUpdate';
//
import Questions from './Questions/Questions';

            import QuestionsAdd from './Questions/QuestionsAdd';

            import QuestionsViewUpdate from './Questions/QuestionsViewUpdate';
//
import Videos from './Videos/Videos';

            import VideosAdd from './Videos/VideosAdd';

            import VideosViewUpdate from './Videos/VideosViewUpdate';
//
import Notes from './Notes/Notes';

            import NotesAdd from './Notes/NotesAdd';

            import NotesViewUpdate from './Notes/NotesViewUpdate';
//
import NotesType from './NotesType/NotesType';

            import NotesTypeAdd from './NotesType/NotesTypeAdd';

            import NotesTypeViewUpdate from './NotesType/NotesTypeViewUpdate';
import Login from "./Login/Login";
//IMPORT-COMPONENT-HERE
export default [
  {
    path: "/",
    exact: true,
    layout: DefaultLayout,
    component: () => <Redirect to="/login" />
  },
  {
    path: "/dashboard",
    layout: DefaultLayout,
    component: Dashboard
  },
  {
    path: "/login",
    layout: Full,
    component: Login
  },
  {
    path: "/appInfo",
    layout: DefaultLayout,
    component: AppInfo
  },
  {
    path: "/user",
    layout: DefaultLayout,
    component: UserList
  },
  {
    path: "/User-add",
    layout: DefaultLayout,
    component: UserAdd
  },
  {
    path: "/User-edit-view/:id",
    layout: DefaultLayout,
    component: UserViewUpdate
  },
  {
    path: "/departments",
    layout: DefaultLayout,
    component: DepartmentsList
  },
  {
    path: "/Departments-add",
    layout: DefaultLayout,
    component: DepartmentsAdd
  },
  {
    path: "/Departments-edit-view/:id",
    layout: DefaultLayout,
    component: DepartmentsViewUpdate
  },
  {
    path: "/user-profile-lite",
    layout: DefaultLayout,
    component: UserProfileLite
  },
  {
    path: "/errors",
    layout: DefaultLayout,
    component: Errors
  },
  {
    path: "/components-overview",
    layout: DefaultLayout,
    component: ComponentsOverview
  },
  {
    path: "/tables",
    layout: DefaultLayout,
    component: Tables
  },
  {
    path: "/blog-posts",
    layout: DefaultLayout,
    component: BlogPosts
  }
  ,{
    path: "/Blog-add",
    layout: DefaultLayout,
    component: AddNewPost
  },{
    path: "/Blog-edit-view/:id",
    layout: DefaultLayout,
    component: AddNewPost
  }
//
,{
              path: '/Bikes',
              layout: DefaultLayout,
              component: Bikes,
                
            },{
              path: '/Bikes-add',
              layout: DefaultLayout,
              component: BikesAdd,
                
            },{
              path: '/Bikes-edit-view/:id',
              layout: DefaultLayout,
              component: BikesViewUpdate,
                
            }
//
,{
              path: '/Courses',
              layout: DefaultLayout,
              component: Courses,
                
            },{
              path: '/Courses-add',
              layout: DefaultLayout,
              component: CoursesAdd,
                
            },{
              path: '/Courses-edit-view/:id',
              layout: DefaultLayout,
              component: CoursesViewUpdate,
                
            }
//
,{
              path: '/category',
              layout: DefaultLayout,
              component: Category,
                
            },{
              path: '/category-add',
              layout: DefaultLayout,
              component: CategoryAdd,
                
            },{
              path: '/category-edit-view/:id',
              layout: DefaultLayout,
              component: CategoryViewUpdate,
                
            }
//
,{
              path: '/SubCategory',
              layout: DefaultLayout,
              component: SubCategory,
                
            },{
              path: '/SubCategory-add',
              layout: DefaultLayout,
              component: SubCategoryAdd,
                
            },{
              path: '/SubCategory-edit-view/:id',
              layout: DefaultLayout,
              component: SubCategoryViewUpdate,
                
            },
            {
              path: '/Chapters',
              layout: DefaultLayout,
              component: Chapters,
                
            },{
              path: '/Chapters-add',
              layout: DefaultLayout,
              component: ChaptersAdd,
                
            },{
              path: '/Chapters-edit-view/:id',
              layout: DefaultLayout,
              component: ChaptersViewUpdate,
                
            },
            {
              path: '/Exercises',
              layout: DefaultLayout,
              component: Exercises,
                
            },{
              path: '/Exercises-add',
              layout: DefaultLayout,
              component: ExercisesAdd,
                
            },{
              path: '/Exercises-edit-view/:id',
              layout: DefaultLayout,
              component: ExercisesViewUpdate,
                
            }
//
,{
              path: '/Questions',
              layout: DefaultLayout,
              component: Questions,
                
            },{
              path: '/Questions-add',
              layout: DefaultLayout,
              component: QuestionsAdd,
                
            },{
              path: '/Questions-edit-view/:id',
              layout: DefaultLayout,
              component: QuestionsViewUpdate,
                
            }
//
,{
              path: '/Videos',
              layout: DefaultLayout,
              component: Videos,
                
            },{
              path: '/Videos-add',
              layout: DefaultLayout,
              component: VideosAdd,
                
            },{
              path: '/Videos-edit-view/:id',
              layout: DefaultLayout,
              component: VideosViewUpdate,
                
            }
//
,{
              path: '/Notes',
              layout: DefaultLayout,
              component: Notes,
                
            },{
              path: '/Notes-add',
              layout: DefaultLayout,
              component: NotesAdd,
                
            },{
              path: '/Notes-edit-view/:id',
              layout: DefaultLayout,
              component: NotesViewUpdate,
                
            }
//
,{
              path: '/Notestype',
              layout: DefaultLayout,
              component: NotesType,
                
            },{
              path: '/Notestype-add',
              layout: DefaultLayout,
              component: NotesTypeAdd,
                
            },{
              path: '/Notestype-edit-view/:id',
              layout: DefaultLayout,
              component: NotesTypeViewUpdate,
                
            }
//REPLACE-COMPONENT-HERE 
];
